import {getField, updateField} from 'vuex-map-fields';
import DEFINES from '@/defines';
import router from '@/router';
import * as API from '@/api';

function initialState () {
  return {
    //FIXME: list is object when serves from api so keep default also object
    list: [],
    screener: null,
  };
}

const state = initialState ();

// actions

const actions = {
  async create (context, payload) {
    var response = await API.screener.create (payload);
    //update list after screener is crated
    await context.dispatch ('list');
    return response;
  },

  async get (context, payload) {
    // var screener = context.getters['getScreener'] (payload.id);
    /* if not in state get from api */
    // if (screener == undefined) {
    //TEMPORARY FIX
    var response = await API.screener.get (payload);
    var screener = response.screener;
    return screener;
  },

  async delete (context, payload) {
    var response = await API.screener.delete (payload);
    return response;
  },

  async list (context, payload) {
    var response = await API.screener.list (payload);
    // set screeners in list
    context.commit ('set_list', {
      screeners: response.screeners,
    });
    return response;
  },

  async update (context, payload) {
    var response = await API.screener.update (payload);
    await context.dispatch ('list');
    return response;
  },

  async updateLiveCounter (context, payload) {
    await context.commit ('update_live_counter', payload);
    return payload;
  },

  async removeGeoBlocking (context, payload) {
    var response = await API.screener.removeGeoBlocking (payload);
    await context.commit ('update_screener', response);
    return response;
  },
  // Sends real time notification to screening page
  async sendNotification (context, payload) {
    var response = await API.screener.sendNotification (payload);
    return response;
  },

  async downloadAllConsumers (context, payload) {
    var response = await API.screener.downloadAllConsumers (payload);
    return response;
  },
  async getStreams (context, payload) {
    var response = await API.screener.getStreams (payload);
    return response;
  },

  async saveStreams (context, payload) {
    var response = await API.screener.saveStreams (payload);
    return response;
  },

  async broadcastStream (context, payload) {
    var response = await API.screener.broadcastStream (payload);
    return response;
  },

  async deactiveStream (context, payload) {
    var response = await API.screener.deactiveStream (payload);
    return response;
  },

  async setPreRoll (context, payload) {
    var response = await API.screener.setPreRoll (payload);
    return response;
  },

  async setPreRoll (context, payload) {
    var response = await API.screener.setPreRoll (payload);
    return response;
  },

  async upgrade (context, payload) {
    var response = await API.screener.upgrade (payload);
    if(response.screener){
      await context.commit ('update_screener', response);
      await context.commit ('company/update_company', response, DEFINES.USE_ROOT);
      await context.commit ('company/set_company', response, DEFINES.USE_ROOT);
    }
    return response;
  },

  async markUpgraded (context, payload) {
    var response = await API.screener.markUpgraded (payload);
    await context.commit ('update_screener', response);
    await context.commit ('company/update_company', response, DEFINES.USE_ROOT);
    await context.commit ('company/set_company', response, DEFINES.USE_ROOT);
    return response;
  },

  async updateSeats (context, payload) {
    var response = await API.screener.updateSeats (payload);
    await context.commit ('update_screener', response);
    return response;
  },
  async listPaymentTransactions (context, payload) {
    var response = await API.screener.listPaymentTransactions (payload);
    return response;
  },
  async importConsumers (context, payload) {
    var response = await API.screener.importConsumers (payload);
    return response;
  },
  /**
   * Get physical events seats status
   */
   async getSeatsStatus(context, payload) {
    var response = await API.screener.getSeatsStatus(payload);
    return response;
  },
   /**
   * Get physical events seats status
   */
    async updatePhysicalVenueSeats(context, payload) {
      var response = await API.screener.updatePhysicalVenueSeats(payload);
      return response;
    },

    /**
   * Get physical events seats category pricing
   */
     async updateCategoriesPricing(context, payload) {
      var response = await API.screener.updateCategoriesPricing(payload);
      return response;
    },

  /**
   * update physical events seats ticket types discount
   */
      async updateTicketTypesDiscount(context, payload) {
        var response = await API.screener.updateTicketTypesDiscount(payload);
        return response;
      },
};

// getters
const getters = {
  getField,
  getScreener: state => id => {
    if (!state.list.data) {
      return null;
    }
    return state.list.data.find (screener => {
      return screener.id == id;
    });
  },
  isScreeningPaid: state => screening => {
    if (!screening) {
      return false;
    }
    return screening.monetization && screening.monetization_enabled;
  },
  isParticipantSlotPaid: state => (screening, slot_id) => {
    if(!screening){
      return false;
    }
    return (
      screening.payment_charges &&
      screening.payment_charges.hasOwnProperty (slot_id) &&
      screening.payment_charges[slot_id].is_paid
    );
  },
};

// mutations
const mutations = {
  updateField,
  set_list (state, payload) {
    state.list = payload.screeners;
  },

  update_live_counter (state, payload) {
    state.list.data.map (screener => {
      if (screener.id == payload.event.screener_id) {
        screener.live_counter = payload.event.live_counter;
        return screener;
      }
    });
  },
  update_screener (state, payload) {
    state.list.data = [
      ...state.list.data.filter (
        screener => screener.id !== payload.screener.id
      ),
      payload.screener,
    ];
  },

  reset (state) {
    // acquire initial state
    const s = initialState ();
    Object.keys (s).forEach (key => {
      state[key] = s[key];
    });
  },
};

export default {
  namespaced: true,
  state,
  actions,
  getters,
  mutations,
};
